<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/warehousesRequest/">Account Request</a></li>
      <li class="breadcrumb-item active" aria-current="page">Verify</li>
    </ol>
  </nav>

  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box" [hidden]="documents?.mouDocument == null">
          <h2 class="text-black text-center"><b>MOU</b></h2>
          <div class="row mt-3">
            <div class="col-lg-2 col-sm-6">
              <label class="text-black"><b>MOU Document</b> </label>
            </div>
            <div class="col-lg-2 col-sm-6">
              <a href="{{documents?.mouDocument}}" target="_blank">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <path fill="none"
                        d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div class="col-md-12 text-right" [hidden]="documents?.isMouVerified =='YES'">
            <button type="reset" data-toggle="modal" data-target="#deleteApiPop" (click)="openPopup()"
                    class="btn btn-cancel">Reject
            </button>
            <button type="submit" (click)="verfiyMouDoc()" class="btn btn-orange ml-2">Verify</button>
          </div>
          <div class="col-md-12 text-right" [hidden]="documents?.isMouVerified !== 'YES'">
            <img src="/./assets/images/tick.svg" class="float-right"
                 title="Verified" style="width: 1.2em; margin-right:0.5em; margin-top:-1.8em;">
          </div>
        </div>
        <div class="inner-box" [hidden]="documents?.mouDocument !== null">
          <h2 class="text-black text-center"><b>MOU</b></h2>
          <div class="row mt-3">
            <div class="col">
              <label class="text-black"><b>Please Upload your MOU Document</b> </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box" [hidden]="documents?.panCardImage == null && documents?.aadharCardImage == null">
          <h2 class="text-black text-center"><b>KYC</b></h2>
          <div class="row mt-3">
            <div class="col-lg-2 col-sm-6">
              <label class="text-black"><b>Pancard</b></label>
            </div>
            <div class="col-lg-2 col-sm-6">
              <a href="{{documents?.panCardImage}}" target="_blank">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <path fill="none"
                        d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-2 col-sm-6">
              <label class="text-black"><b>Aadhar card</b></label>
            </div>
            <div class="col-lg-2 col-sm-6" [hidden]="documents?.aadharCardImage == null">
              <a href="{{documents?.aadharCardImage}}" target="_blank">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <path fill="none"
                        d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div class="col-md-12 text-right" [hidden]="documents?.isKycVerified == 'YES'">
            <button type="reset" data-toggle="modal" data-target="#deleteApiPop1" (click)="openPopupKyc()"
                    class="btn btn-cancel">Reject
            </button>
            <button type="submit" (click)="verfiyKycDoc()" class="btn btn-orange ml-2">Verify</button>
          </div>
          <div class="col-md-12 text-right" [hidden]="documents?.isKycVerified !== 'YES'">
            <img src="/./assets/images/tick.svg" class="float-right"
                 style="width: 1.2em; margin-right:0.5em; margin-top:-1.8em;"
                 title="Verified">
          </div>
        </div>
        <div class="inner-box" [hidden]="documents?.panCardImage !== null && documents?.aadharCardImage !== null">
          <h2 class="text-black text-center"><b>KYC</b></h2>
          <div class="row mt-3">
            <div class="col">
              <label class="text-black"><b>Please Upload Your Kyc Documents</b></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="cancel" routerLink="/admin/warehousesRequest" class="btn btn-cancel">Back</button>
    </div>
  </div>
</div>


<div class="container">
  <div class="modal fade" id="deleteApiPop" role="dialog">
    <div class="modal-dialog">
      &lt;!&ndash; Modal content&ndash;&gt;
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Reason for Rejection</h4>
          <button type="button" class="close" (click)="closePopup()" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-9">
              <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">
                {{statusText1}}
              </div>
              <select class="form-control" id="reasons" [(ngModel)]="reasons" [ngModelOptions]="{standalone: true}"
                      required>
                <option value="Name on both documents does not match">Name on both documents does not match</option>
                <option value="Mentioned document ID is Incorrect">Mentioned document ID is Incorrect</option>
                <option value="Uploaded document are not valid ones">Uploaded document are not valid ones</option>
                <option value="Document belong to an underage person">Document belong to an underage person</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closePopup()">Cancel</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="RejectMouDoc()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="modal fade" id="deleteApiPop1" role="dialog">
    <div class="modal-dialog">
      &lt;!&ndash; Modal content&ndash;&gt;
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Reason for Rejection</h4>
          <button type="button" class="close" (click)="closePopupKyc()" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-9">
              <div id="statusText" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText">
                {{statusText}}
              </div>
              <select class="form-control" id="reason" [(ngModel)]="reason" [ngModelOptions]="{standalone: true}"
                      required>
                <option value="Name on both documents does not match">Name on both documents does not match</option>
                <option value="Uploaded images are not clear">Uploaded images are not clear</option>
                <option value="Uploaded photocopy image does not match with the original document image">Uploaded
                  photocopy image does not match with the original document image
                </option>
                <option value="Mentioned document ID is Incorrect">Mentioned document ID is Incorrect</option>
                <option value="Uploaded documents are not valid ones">Uploaded documents are not valid ones</option>
                <option value="Same document image uploaded for both documents">Same document image uploaded for both
                  documents
                </option>
                <option value="Document belong to an underage person">Document belong to an underage person</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closePopupKyc()">Cancel</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="RejectKycDoc()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>
